import { Component, OnInit } from '@angular/core';
import { SelectionListBaseComponent } from '../selection-list-base/selection-list-base.component';
import { DaysOption } from 'app/shared/models/days-option.model';

@Component({
  selector: 'app-number-of-days-selection-list',
  templateUrl: './number-of-days-selection-list.component.html',
  styleUrls: ['./number-of-days-selection-list.component.scss']
})

export class NumberOfDaysSelectionListComponent extends SelectionListBaseComponent<object> implements OnInit {

  daysOptions: Array<DaysOption>;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.loadSelectionList();
  }

  protected loadSelectionList(): void {
    this.daysOptions = Array.from({length: 31}, (_, i) => {
      const key = (i + 1 === 1) ? 'numberOfDays.singularOptionText' : 'numberOfDays.pluralOptionText';
      return new DaysOption(i + 1, key);
    });
  }
}
